import { loadStripe, type Stripe } from '@stripe/stripe-js';
import { env } from '@/shared/config/env';

/** The isolated checkout is available when a publishable key is configured. */
export const checkoutEnabled = env.VITE_STRIPE_PUBLISHABLE_KEY.length > 0;

let stripePromise: Promise<Stripe | null> | null = null;

/** Lazily load Stripe.js once, only when the checkout renders the card form. */
export function getStripe(): Promise<Stripe | null> {
  stripePromise ??= loadStripe(env.VITE_STRIPE_PUBLISHABLE_KEY);
  return stripePromise;
}
